import React from "react";

import { Menu } from "@mui/material";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import IconButton, { IconButtonProps } from "@rui/IconButton";
import MenuItem from "@rui/MenuItem";
import { Row } from "@rui/Stack";

export const ButtonContainer = styled(Row)(({ theme }) => ({
  border: `1px solid ${theme.palette.shades.primary[500]}`,
  borderRadius: theme.corners.base,
  gap: "2px",
  padding: "1px",
  [theme.breakpoints.up("md")]: {
    "& .divider.no-options": {
      display: "none",
    },
    "& .lt-md": {
      display: "none",
    },
  },
  [theme.breakpoints.down("md")]: {
    "& .gte-md": {
      display: "none",
    },
    "& span:has(> .LogoIconButton)": {
      display: "none",
    },
  },
  "&.disabled": {
    border: `1px solid ${theme.palette.shades.neutral[100]}`,
  },
}));

export const ResponsiveMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    padding: "14px",
  },
  "& .MuiList-root": {
    padding: 0,
  },
  [theme.breakpoints.up("md")]: {
    "&.lt-md": {
      display: "none",
    },
  },
  [theme.breakpoints.down("md")]: {
    "&.gte-md": {
      display: "none",
    },
  },
}));

type LogoIconButtonProps = IconButtonProps & { iconSrc?: string; alt?: string };

export const LogoIconButton = styled<React.FC<LogoIconButtonProps>>(
  ({ iconSrc, alt, ...props }) => (
    <IconButton
      {...props}
      className={`LogoIconButton${props.className ? ` ${props.className}` : ""}`}
    >
      <img src={iconSrc} alt={alt} />
    </IconButton>
  )
)(({ theme }) => ({
  borderRadius: theme.corners.base,
  height: "40px",
  width: "40px",
  img: {
    display: "block",
    height: "20px",
    width: "20px",
  },
  "&.Mui-disabled": {
    border: "none",
    backgroundColor: theme.palette.transparent.black[4],

    "& img": {
      filter: "grayscale(100%)",
      opacity: "0.6",
    },
  },
}));

export const MenuItemRow = styled(Row)({
  flex: 1,
  gap: "16px",
  alignItems: "center",
  padding: "4px",
});

export const LogoMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: 0,
  "& *:has(> img)": {
    borderRadius: "6px",
    padding: "8px",
  },
  "&.Mui-disabled": {
    opacity: 1,
    border: "none",
    backgroundColor: "unset",
    "& .MuiTypography-root": {
      opacity: 0.38,
    },
    "& *:has(> img)": {
      backgroundColor: theme.palette.transparent.black[4],

      "& img": {
        filter: "grayscale(100%)",
        opacity: "0.6",
      },
    },
    "& .MuiButtonBase-root": {
      pointerEvents: "all",
    },
  },
  img: {
    display: "block",
    height: "20px",
    width: "20px",
  },
}));

export const TooltipContent = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="label1">{children}</Typography>
);
